import { Sound } from "@pixi/sound";

export let betValueGlobal: number = 1;
export function setBetValueGlobal(val: number): void {
    betValueGlobal = val;
}


export let isSoundBtnOnGlobal: boolean = true;
export function setIsSoundBtnOnGlobal(val: boolean): void {
    isSoundBtnOnGlobal = val;
}


export let isMusicBtnOnGlobal: boolean = true;
export function setIsMusicBtnOnGlobal(val: boolean): void {
    isMusicBtnOnGlobal = val;
}


export let isGameAlreadyLoaded: boolean = false;
export function setIsGameAlreadyLoaded(val: boolean): void {
    isGameAlreadyLoaded = val;
}


// export let isFullscreenBtnOnGlobal: boolean = false;
// export function setIsFullscreenBtnOnGlobal(val: boolean): void {
//     isFullscreenBtnOnGlobal = val;
// }


export let spinResponseDataGlobal: any;
export function setSpinResponseDataGlobal(val: any): void {
    spinResponseDataGlobal = val;
}


// Private variable to hold the current value
let _currentRespinIndex: number = 0;


export const RespinIndex = {
    get value(): number {
        return _currentRespinIndex;
    },
    set value(newValue: number) {
        _currentRespinIndex = newValue;
    },
    increase(): void {
        _currentRespinIndex++;
    },
    reset(): void {
        _currentRespinIndex = 0;
    }
};



export let currentBackgorundMusic: Sound | null = null;

export function setBackgorundMusic(val: Sound): void {
    currentBackgorundMusic = val;
}

export const currentBackgorundMusicVolume: number = 0.6;


export let isQuickBtnOnGlobal: boolean = false;
export function setIsQuickBtnOnGlobal(val: boolean): void {
    isQuickBtnOnGlobal = val;
}

export let isSuperQuickBtnOnGlobal: boolean = false;
export function setIsSuperQuickBtnOnGlobal(val: boolean): void {
    isSuperQuickBtnOnGlobal = val;
}

export let jurisdictionGlobal: string = "";
export function setJurisdictionGlobal(val: string): void {
    jurisdictionGlobal = val;
}

export let willBannerAutoProceedGlobal: boolean = false;
export function setBannerAutoProceedGlobal(val: boolean): void {
    willBannerAutoProceedGlobal = val;
}


let resolveMaxWinClosed: (() => void) | null = null;

export let isMaxWinBtnClosedGlobal: boolean = false;

export function setMaxWinBtnClosedGlobal(val: boolean): void {
    isMaxWinBtnClosedGlobal = val;

    if (val && resolveMaxWinClosed) {
        resolveMaxWinClosed();
        resolveMaxWinClosed = null;
    }
}

export function waitUntilMaxWinBtnClosed(): Promise<void> {
    return new Promise<void>((resolve) => {
        resolveMaxWinClosed = resolve;
    });
}

export let languageGlobal: string = "";
export function setLanguageGlobal(val: string): void {
    languageGlobal = val;
}

export let isMobile: Boolean = false;
export function setMobileDetect(val: Boolean): void {
    isMobile = val;
}

export function getMobileDetect(): Boolean  {
    return isMobile;
}

export let linesConfigGlobal: number[][] = [];
export function setLinesGlobal(val: string[][]): void {
    // Convert string[][] to number[][]
    const converted: number[][] = val.map(line =>
        line.map(cell => Number(cell))
    );
    linesConfigGlobal = converted;
}

export let isSlamClickedGlobal: boolean = false;
export function setIsSlamClickedGlobal(val: boolean): void {
    isSlamClickedGlobal = val;
}


export let isDoubleReelFeature: Boolean;
export function setDoubleReelFeature(val: boolean): void {
    isDoubleReelFeature = val;
}

export let baseGameLastReeelSymbols: number[][] = [];
export function setbaseGameLastReeelSymbols(val: number[][]): void {
    baseGameLastReeelSymbols = val;
}

export interface IBetDetails {
    betAmount: number,
    bonusBuy: boolean,
    bonusBuyId: string,
}

let betDetails: IBetDetails = {
    betAmount: 0,
    bonusBuy: false,
    bonusBuyId: "",
}

export function setCurrentRoundBetDetails(betAmount: number, bonusBuy: boolean, bonusBuyId: string) {
    betDetails.betAmount = Number(betAmount) / 100;
    betDetails.bonusBuy = bonusBuy;
    betDetails.bonusBuyId = bonusBuyId;
}

export function getCurrentRoundBetDetails(): IBetDetails {
    return betDetails;
}